export default "__VITE_ASSET__Dmz4TuK2__"